import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../../assets/images/logo.png";
import Seo from "../../components/Seo";
import { apiErrorMessage, lawyerAuth, lawyerService } from "../../services/lawyerApi";
import "../../components/lawyer/lawyer.css";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const LawyerLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || lawyerAuth.getPendingEmail());
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if (!EMAIL_RE.test(value)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      const res = await lawyerService.login(value);
      if (res?.data?.status) {
        toast.success(res.data.message || "OTP sent to your email");
        lawyerAuth.setPendingEmail(value);
        navigate("/lawyer/verify-otp", { state: { email: value } });
      } else {
        toast.error(res?.data?.message || "Unable to login.");
      }
    } catch (err) {
      toast.error(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate("/"));

  return (
    <div className="lwp lwp-auth">
      <Seo title="Lawyer Login | Legal Platform" noindex />
      <div className="lwp-auth-card">
        {/* <button type="button" className="lwp-back" onClick={goBack} aria-label="Go back">
          <i className="bi bi-chevron-left" />
        </button> */}

        <img src={logo} alt="Legal Platform" className="lwp-auth-logo" />

        <h1 className="lwp-auth-title">Welcome Back!</h1>

        <form onSubmit={handleSubmit} noValidate>
          <input
            type="email"
            className="lwp-input"
            placeholder="Email*"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            autoFocus
            required
          />
          <button type="submit" className="lwp-btn" disabled={loading}>
            {loading ? <span className="spinner-border spinner-border-sm" /> : "Login"}
          </button>
        </form>

        <p className="lwp-auth-footer">
          Don&apos;t have an account? <Link to="/lawyer-registration">Sign up</Link>
        </p>
      </div>
    </div>
  );
};

export default LawyerLogin;
